var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Close site navigation"),React.createElement("path",{"d":"M1.23223 0.767767C2.20854 -0.208544 3.9203 -0.0797019 5.05554 1.05554L36.2998 32.2998C37.435 33.435 37.5639 35.1468 36.5876 36.1231C35.6113 37.0994 33.8995 36.9706 32.7643 35.8353L1.52001 4.59108C0.384763 3.45583 0.255921 1.74408 1.23223 0.767767Z","fill":"#333333","key":1}),React.createElement("path",{"d":"M0.767765 36.1231C-0.208545 35.1468 -0.0797038 33.435 1.05554 32.2998L32.2998 1.05554C33.435 -0.0797001 35.1468 -0.208542 36.1231 0.767769C37.0994 1.74408 36.9706 3.45583 35.8353 4.59108L4.59108 35.8353C3.45583 36.9706 1.74408 37.0994 0.767765 36.1231Z","fill":"#333333","key":2})]);
}

IconClose.defaultProps = {"width":"18","height":"18","viewBox":"0 0 38 37","fill":"none"};

module.exports = IconClose;

IconClose.default = IconClose;
